import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as d3 from 'd3';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icons_solid from '@fortawesome/free-solid-svg-icons';
import './Funnel_v2.scss';

const GRID_HEIGHT = 300;
const MIN_CARD_HEIGHT = 120;

export default ({ data, data_raw, graph_header, path, status_key = 'enrollment_status' }) => {
	const navigate = useNavigate();
	const [expanded, setExpanded] = useState({});

	const goSubjects = useCallback(({ status }) => {
		// Note: Using window.location.href instead of location because the graph is always going to be
		// using a stale callback.
		const search = (new URL(window.location.href)).searchParams;
		search.set(status_key, status);
		// FIXME: This is cheating. Making them exclusive for the time being.
		if (status_key === 'deal_status') {
			search.delete('enrollment_status');
		} else if (status_key === 'enrollment_status') {
			search.delete('deal_status');
		}
		navigate({ pathname: path, search: search.toString() });
	});

	const toggleExpanded = useCallback((key, value) => {
		setExpanded(prev => ({ ...prev, [key]: value !== undefined ? value : !prev[key] }));
	}, [JSON.stringify(expanded)]);

	const grid = () => {
		let z = 100;
		const dataTop = data.filter(e => e.label.indexOf('::') === -1);
		const maxHeight = _.maxBy(dataTop, 'value')?.value;
		console.log('maxHeight', maxHeight);
		const cols = dataTop.map((_dataTop, _dataTop_i) => {
			const labelTop = _dataTop.label;
			const valueTop = _dataTop.value;
			let filteredData = [];
			if (_dataTop_i < dataTop.length - 1) {
				filteredData = data.filter(e => e.value > 0 && e.label.indexOf('::') !== -1 && e.priority === _dataTop.priority);
				const pending = data_raw.find(e => e.label === dataTop[_dataTop_i].label);
				if (pending?.value >= 1) {
					// Punch in a Pending
					filteredData.unshift({
						backgroundColor: '#FEB5EA',
						label: `${pending.label}::Pending`,
						value: pending.value
					});
				}
			}
			const height = Math.max(
				maxHeight > 0 ? (valueTop * GRID_HEIGHT) / maxHeight : 0,
				MIN_CARD_HEIGHT
			);
			const cpa = graph_header?.total_spend && valueTop > 0 ? <><span>&nbsp;&nbsp;</span><span style={{fontSize: '13px'}}>CPA </span><span>{d3.format('$,.2f')(graph_header.total_spend / valueTop)}</span></> : undefined;
			return (
			<div className="position-relative" key={_dataTop_i} style={{ backgroundColor: 'white', gridColumn: 'span 1', height: GRID_HEIGHT, zIndex: z-- }}>
                    <div className="fg-423894 position-relative text-left ps-3 cursor-pointer" style={{ backgroundColor: '#E5E5E5', gridColumn: 'span 1', height, zIndex: z--, borderTopLeftRadius: '9px', borderBottomLeftRadius: '9px',paddingTop: '15px'  }} onClick={() => goSubjects({ status: labelTop })}>
                        {/* Label */}
                        <div style={{
                            fontSize: '12px',
                            fontWeight: '700',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                            color: '#2E2868',
                            marginBottom: '10px',
                            fontSize: 'clamp(10px, 1.2vw, 14px)',
                        }}>{labelTop}</div>
                        {/* Value */}
                        <div style={{
                            fontSize: '25px',
                            fontWeight: '600',
                            lineHeight: '26px',
                            color: '#2E2868',
                        }}>{d3.format(',')(valueTop)}<span style={{ fontSize: '15px' }}>{cpa}</span></div>
                    </div>
                    <div className="position-absolute" style={{ backgroundColor: 'white', height: GRID_HEIGHT, zIndex: z-- }}></div>
                    
                        <div className={`position-absolute py-2 expander ${expanded[labelTop] ? 'expanded' : ''}`} style={{
                            "--child-count": filteredData.length, backgroundColor: '#FEB5EA', minHeight: height, paddingRight: '20px', right: '-20px', top: 0, width: 'auto', zIndex: z--, borderTopRightRadius: '9px',
                            borderBottomRightRadius: '12px'
                        }} onMouseEnter={() => toggleExpanded(labelTop, true)} onMouseLeave={() => toggleExpanded(labelTop, false)}>
                            <FontAwesomeIcon className="position-absolute cursor-pointer" icon={icons_solid.faAngleRight} size="lg" onClick={() => toggleExpanded(labelTop)} style={{ right: 5, bottom: '0.7rem' }} />
							{filteredData.map((e, i) => {
								const label = e.label.split('::')[1];
								return (
									<div
										key={i}
										className="ms-2 p-0 m-0 btn-link text-decoration-none text-nowrap cursor-pointer fg-423894"
										onClick={() => goSubjects({ status: e.label })}
										style={{
											fontSize: '13px',
											height: '20px',
											lineHeight: '20px',
											overflow: 'hidden',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											gap: '29px',
											boxSizing: 'border-box',
											width: '100%', 
											padding: '0', 
										}}
									>
										<span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</span>
										<span style={{ marginLeft: '22px', fontWeight: 700, textAlign: 'right' }}>{d3.format(',')(e.value)}</span>
									</div>
									
								);
							})}

                        </div>
                   
                </div>

			);
		});
		return (
			<div style={{display: 'grid', gap: '30px', gridTemplateColumns: `repeat(${dataTop.length}, 1fr)`}}>
				<>
					{cols}
				</>
			</div>
		);
	};

	return (
		<AnimatePresence initial={true}>
			<motion.div
				key="content"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1.0 }}
				transition={{ duration: 0.25, ease: 'easeInOut' }}
			>
				{grid()}
			</motion.div>
		</AnimatePresence>
	);
};